import { Flex } from '@chakra-ui/react';
import SubmissionFiles from 'src/components/Submission/SubmissionFiles';
import { useReviewData } from 'src/contexts/ReviewDataProvider';

export const SubmissionFilesDetails = () => {
  const { fieldsResponse } = useReviewData();

  return (
    <Flex flexDirection="column" gap={4}>
        {fieldsResponse.fields['Supplementary']?.value ||
        fieldsResponse.fields['Manuscript']?.value ||
        fieldsResponse.fields['CompleteDocumentForReview']?.value ||
        fieldsResponse.fields['AnonymizedManuscript']?.value ||
        fieldsResponse.fields['Figures']?.value ||
        fieldsResponse.fields['Tables']?.value ? (
          <SubmissionFiles isHeaderRequired={false} />
        ) : null}
    </Flex>
  );
};
